module.exports = __webpack_public_path__ + "static/media/programblad.09f78bae.png";